import { ChronoUnit, LocalDateTime } from "@js-joda/core";
import { differenceInCalendarDays, startOfDay } from "date-fns";

export function formatDateAndTime(dateIsoString) {
  if (!dateIsoString) {
    return "-";
  }

  const date = new Date(dateIsoString);
   if (isNaN(date.getTime())) return '—';
   
  const formatter = new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
  });

  const formattedDate = formatter.format(date);

  return formattedDate;
}

export function formatDate(dateIsoString) {
  if (!dateIsoString) {
    return "-";
  }
  const date = new Date(dateIsoString);
  const formatter = new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short', // Isso formatará apenas a data
    timeZone: 'UTC', // Forçar o uso do fuso horário UTC para evitar ajustes automáticos de fuso horário
  });

  const formattedDate = formatter.format(date);

  return formattedDate;
}

export function convertMonthsToWeeks(months: number) {
  const dt = LocalDateTime.now();

  return dt.until(dt.plusMonths(months), ChronoUnit.WEEKS);
}

export function brDateFormat(dateIsoString) {
  const date = new Date(dateIsoString)
  const formatter = new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })

  const formattedDate = formatter.format(date).split('/').join('/')

  return formattedDate
}

export function brDateHourFormat(dataISO) {
  const data = new Date(dataISO);

  function monthName(month) {
    const months = [
      'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
      'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
    ];
    return months[month];
  }
  const day = data.getDate();
  const month = monthName(data.getMonth());
  const year = data.getFullYear();
  const hours = data.getHours();
  const minutes = data.getMinutes();

  return `${day} de ${month} de ${year}, às ${hours}:${minutes}.`;
}
function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}

export function formatDateNoHours(dateIsoString) {
  const date = new Date(dateIsoString);
  return [
    padTo2Digits(date.getDate()),
    padTo2Digits(date.getMonth() + 1),
    date.getFullYear(),
  ].join('/');
}

export function settingAge(birthDate: string): number {
  const [day, month, year] = birthDate.split('/');
  const formatedDate = `${month}/${day}/${year}`;

  const birthDateData = new Date(formatedDate);

  const currentDate = new Date();

  let currentAge = currentDate.getFullYear() - birthDateData.getFullYear();
  const currentMonth = currentDate.getMonth();
  const birthMonth = birthDateData.getMonth();

  if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDate.getDate() < birthDateData.getDate())) {
    currentAge--;
  }

  return currentAge;
}

export function getDaysUntilExpiration(endDate: Date | undefined): string {
  if (!endDate) return 'Data não disponível';

  const end = startOfDay(new Date(endDate));
  const now = startOfDay(new Date());

  const dayDiff = differenceInCalendarDays(end, now);

  if (dayDiff > 0) {
    return `${dayDiff} dias`;
  } else if (dayDiff < 0) {
    return `Vencido há: ${Math.abs(dayDiff)} dias`;
  } else {
    return 'Expira hoje';
  }
}
